import { _lang, lang } from '@umu/ukit-lang';
// @ts-ignore
import en_US from '@umu/umu-slide-picker/dist/locale/en_US';
// @ts-ignore
import zh_CN from '@umu/umu-slide-picker/dist/locale/zh_CN';

export const localeConfig = {
    locale: en_US,
};

if (_lang('CN')) {
    localeConfig.locale = zh_CN;
}

/**
 * 除了cn站为中文，其他默认都是EN
 */

export const WEEK_TEXT_MAP = {
    0: lang('日'),
    1: lang('一'),
    2: lang('二'),
    3: lang('三'),
    4: lang('四'),
    5: lang('五'),
    6: lang('六'),
};

export type WeekType = '0' | '1' | '2' | '3' | '4' | '5' | '6';
export const DATE_FORMAT = 'YYYY-MM-DD';
export const TIME_FORMAT = 'YYYY-MM-DD HH:mm';
export const TIME_FORMAT_SHOW = 'HH:mm';
